import * as React from "react";
import { FormSection } from "./components/FormSection";
import { ComplianceSection } from "./components/ComplianceSection";
import Heading from "../../components/Heading";
import { ActionButton } from "../../components/Forms/ActionButton";
import ImageInput from "../../components/Forms/ImageInput";
import FileHandler from "../../components/Forms/FileHandler";
import { createCompany, updateCompany } from "../../api/users";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from "react-router-dom";
import { useGetCompanyInfo } from "../../queries/user";
import { useGetProductCategories } from "../../queries/products";
import MediaUpload from "../../components/Forms/MediaUpload";
import Select from 'react-select';
import ActiveStatus from "../../components/Common/ActiveStatus";

export const CompanyForm = () => {

    const { state } = useLocation();
    const companyId = state?._id;

    const navigate = useNavigate();

    const { data, isLoading } = useGetCompanyInfo(companyId);
    const { data: productCategories = [] } = useGetProductCategories();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
        setValue,
        watch,
        getValues,
        setError,
        clearErrors,
    } = useForm({
        defaultValues: {
            // Company Information
            companyName: '',
            industryOrSector: '',
            description: '',
            branchAddress: '',
            phone: '',
            email: '',
            headquarterAddress: '',
            websiteUrl: '',
            registrationNumber: '',
            taxIdentificationNumber: '',
            username: '',
            displayName: '',
            emailRecipients: '',
            linkedIn: '',
            instagram: '',
            facebook: '',
            twitter: '',
            youtube: '',
            pocName: '',
            pocDesignation: '',
            pocDepartment: '',
            pocPhone: '',
            pocMobile: '',
            pocEmail: '',
            typeOfPartnership: [],
            partnershipObjective: '',
            partnershipStartDate: '',
            categoryOfChallengePreferred: '',
            rewardsOffered: '',
            rewardsMode: '',
            advertisementType: '',
            preferredPlacementSlot: '',
            advertisementDetails: '',
            sponsorMessage: '',
            numberOfProductsOnOffer: '',
            typeOfProductsOnOffer: '',
            priceRangeOfProductsOnOffer: '',
            detailsOfDonationPreference: '',
            detailsOfSpecificProjects: '',
            detailsOfCSRGoals: '',
            categoryOfProducts: '',
            priceRangeOfProducts: '',
            detailsOfProducts: '',
            offerType: '',
            brandPromotionAdvertisementType: '',
            brandPromotionAdvertisementDetails: '',
            brandPromotionPreferredPlacementSlot: '',
            brandMessage: '',
            categoryOfProjects: '',
            numberOfProjects: '',
            locationOfProjects: '',
            detailsOfProjects: '',
            fundRaiseTarget: '',
            platformFeeAgreement: false,
            developerMessage: '',
            categoryOfProjectsPreferred: '',
            donationMatchingRatio: '',
            detailsOfProjectsPreferred: '',
            detailsOfCSRESGGoals: '',
            detailsAboutDonationBudget: '',
            donorMessage: '',
            advertisementCommodity: '',
            advertisementGoal: '',
            advertiserAdvertisementType: '',
            advertiserPreferredPlacementSlot: '',
            advertiserAdvertisementDetails: '',
            advertisementBudget: '',
            targetDemographicsCriteria: '',
            targetDemographicValues: '',
            brandAwareness: '',
            leadGeneration: '',
            csr: '',
            esg: '',
            bankAccountDetails: '',
            paymentTerms: '',
            agreementOnRevenueShareOrCommissionRates: '',
            metricsDataPoints: [],
            reportingFrequency: '',
            aShortParagraphOnTheSponsorCompany: '',
            reportingGoals: '',
            remarksOrNotes: '',
            complianceAndAgreements: {
                agreements: [],
                dataPrivacyComplianceAcknowledgement: ''
            },
            newComplianceDocuments: [],
        }
    });

    const watchedTypeOfPartnership = watch('typeOfPartnership');

    // Company Information fields configuration
    const formData = [
        { label: 'Company Name', placeholder: 'Enter Company Name', name: 'companyName', required: true },
        { label: 'Industry/Sector', placeholder: 'Enter Industry/Sector', name: 'industryOrSector' },
        { label: 'Short Description Of Company’s Services/Products', placeholder: 'Write A Short Description Of Company’s Services/Products', name: 'description' },
        { label: 'Branch Address', placeholder: 'Enter Branch Address', name: 'branchAddress', required: true },
        { label: 'Phone Number', placeholder: 'Enter Phone Number', name: 'phone', required: true },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', required: true },
        { label: 'Headquarter Address', placeholder: 'Enter Headquarter Address', name: 'headquarterAddress', required: true },
        { label: 'Website Url', placeholder: 'Enter Website Url', name: 'websiteUrl', required: true },
        { label: 'Registration Number', placeholder: 'Enter Registration Number', name: 'registrationNumber', required: true },
        { label: 'Tax Identification Number', placeholder: 'Enter Tax Identification Number', name: 'taxIdentificationNumber', required: true },
    ];

    const socialFields = [
        { label: 'LinkedIn Account Link', placeholder: 'Enter LinkedIn Account Link', name: 'linkedIn', value: '' },
        { label: 'Instagram Account Link', placeholder: 'Enter Instagram Account Link', name: 'instagram', value: '' },
        { label: 'Facebook Account Link', placeholder: 'Enter Facebook Account Link', name: 'facebook', value: '' },
        { label: 'Twitter Account Link', placeholder: 'Enter Twitter Account Link', name: 'twitter', value: '' },
        { label: 'YouTube Account Link', placeholder: 'Enter YouTube Account Link', name: 'youtube', value: '' }
    ];

    // Account Details fields configuration
    const accountFields = [
        { label: 'Username', placeholder: 'Enter Username', name: 'username', required: true },
        // { label: 'Password', placeholder: 'Enter Password', name: 'password', required: true },
        { label: 'Display Name', placeholder: 'Enter Display Name', name: 'displayName', required: false },
        { label: 'Send Email To (Separate by commas)', placeholder: 'Enter Email Addresses', name: 'emailRecipients', required: true },
    ];

    const pocFields = [
        { label: 'Name', placeholder: 'Enter POC Name', name: 'pocName', value: '', required: true },
        { label: 'Designation', placeholder: 'Enter POC Designation', name: 'pocDesignation', value: '' },
        { label: 'Department', placeholder: 'Enter POC Department', name: 'pocDepartment', value: '' },
        { label: 'Phone Number', placeholder: 'Enter POC Phone', name: 'pocPhone', value: '' },
        { label: 'Mobile Number', placeholder: 'Enter POC Mobile', name: 'pocMobile', value: '' },
        { label: 'Email Address', placeholder: 'Enter POC Email', name: 'pocEmail', value: '', required: true },
    ];

    const partnerFields = [
        {
            label: 'Type Of Partnership', placeholder: 'Select Type Of Partnership', name: 'typeOfPartnership', value: '', type: 'select', data: [
                { value: 'Sponsorship', label: 'Sponsorship' },
                { value: 'Brand/Product Promotion', label: 'Brand/Product Promotion' },
                { value: 'Advertiser', label: 'Advertiser' },
                { value: 'Plant Trees', label: 'Plant Trees' },
                { value: 'Promote an Event', label: 'Promote an Event' },
                { value: 'CSR/ESG', label: 'CSR/ESG' },
            ]
        },
        {
            label: 'Partnership Objective', placeholder: 'Select Partnership Objective', name: 'partnershipObjective', value: '', type: 'select', data: [
                { value: 'Lead Generation', placeholder: 'Lead Generation' },
                { value: 'Brand Promotion', placeholder: 'Brand Promotion' },
                { value: 'Boost sales', placeholder: 'Boost sales' },
                { value: 'Project Awareness', placeholder: 'Project Awareness' },
                { value: 'User Engagement', placeholder: 'User Engagement' },
                { value: 'Offers/Promotions', placeholder: 'Offers/Promotions' },
                { value: 'Advertisement', placeholder: 'Advertisement' },
                { value: 'CSR/ESG', placeholder: 'CSR/ESG' },
            ]
        },
        { label: 'Partnership Start Date', placeholder: 'Select Partnership Start Date', name: 'partnershipStartDate', value: '', type: 'date' },
        {
            label: 'Category Of Challenge Preferred', placeholder: 'Select Category Of Challenge Preferred', name: 'categoryOfChallengePreferred', value: '', type: 'select', data: [
                { value: 'Travel', placeholder: 'Travel' },
                { value: 'Electricity', placeholder: 'Electricity' },
            ]
        },
        {
            label: 'Rewards Offered', placeholder: 'Select Rewards Offered', name: 'rewardsOffered', value: '', type: 'select', data: [
                { value: 'Product Discount', placeholder: 'Product Discount' },
                { value: 'Free Product', placeholder: 'Free Product' },
                { value: 'Free Service', placeholder: 'Free Service' },
                { value: 'Discount on Service', placeholder: 'Discount on Service' },
            ]
        },
        {
            label: 'Rewards Mode', placeholder: 'Select Rewards Mode', name: 'rewardsMode', value: '', type: 'select', data: [
                { value: 'Digital Coupons', placeholder: 'Digital Coupons' },
                { value: 'Points', placeholder: 'Points' },
                { value: 'Both', placeholder: 'Both' },
            ]
        },
        {
            label: 'Advertisement Type', placeholder: 'Select Advertisement Type', name: 'advertisementType', value: '', type: 'select', data: [
                { value: 'Scroll Ads', placeholder: 'Scroll Ads' },
                { value: 'Sticky Ads', placeholder: 'Sticky Ads' },
                { value: 'Banner', placeholder: 'Banner' },
                { value: 'Video', placeholder: 'Video' },
                { value: 'Native', placeholder: 'Native' },
                { value: 'Pop-Up Ads', placeholder: 'Pop-Up Ads' },
                { value: 'Sponsored Content', placeholder: 'Sponsored Content' },
                { value: 'Carousel', placeholder: 'Carousel' },
                { value: 'Reward Based Ad', placeholder: 'Reward Based Ad' },
                { value: 'Interactive Ads', placeholder: 'Interactive Ads' },
            ]
        },
        {
            label: 'Preferred Placement Slot', placeholder: 'Select Preferred Placement Slot', name: 'preferredPlacementSlot', value: '', type: 'select', data: [
                { value: 'knowledge-board-videos', placeholder: 'Knowledge Board - Videos' },
                { value: 'knowledge-board-tips', placeholder: 'Knowledge Board - Tips' },
                { value: 'knowledge-board-news', placeholder: 'Knowledge Board - News' },
                { value: 'new-challenges', placeholder: 'New Challenges' },
                { value: 'eco-activities', placeholder: 'Eco Activities' },
                { value: 'blogs', placeholder: 'Blogs' },
                { value: 'events', placeholder: 'Events' },
                { value: 'challenges-homepage', placeholder: 'Challenges Homepage' },
            ]
        },
        { label: 'Advertisement Details', placeholder: 'Select Advertisement Details', name: 'advertisementDetails', value: '', type: 'textarea', data: [] },
        { label: 'Sponsor Message', placeholder: 'Select Sponsor Message', name: 'sponsorMessage', value: '', type: 'textarea' },
        { label: 'Number Of Products On Offer', placeholder: 'Select Number Of Products On Offer', name: 'numberOfProductsOnOffer', value: '', type: 'number' },
        { label: 'Type Of Products On Offer', placeholder: 'Select Type Of Products On Offer', name: 'typeOfProductsOnOffer', value: '', type: 'text' },
        { label: 'Price Range Of Products On Offer', placeholder: 'Select Price Range Of Products On Offer', name: 'priceRangeOfProductsOnOffer', value: '', type: 'text' },
        { label: 'Details Of Donation Preference', placeholder: 'Enter Details Of Donation Preference', name: 'detailsOfDonationPreference', value: '' },
        { label: 'Details Of Specific Projects', placeholder: 'Enter Details Of Specific Projects', name: 'detailsOfSpecificProjects', value: '' },
        { label: 'Details Of CSR Goals', placeholder: 'Enter Details Of CSR Goals', name: 'detailsOfCSRGoals', value: '' },
    ];

    const brandPromotion = [
        {
            label: 'Category of Products', placeholder: 'Select Category of Products', name: 'categoryOfProducts', type: 'select', value: '', data: productCategories.map(cat => ({
                value: cat.name || cat.label, placeholder: cat.name || cat.label
            }))
        },
        { label: 'Price Range of Products', placeholder: 'Enter Price Range of Products', name: 'priceRangeOfProducts', type: 'text', value: '', data: [] },
        { label: 'Details of Products', placeholder: 'Enter Details of Products', name: 'detailsOfProducts', type: 'text', value: '', data: [] },
        {
            label: 'Offer Type', placeholder: 'Selct Offer Type', name: 'offerType', type: 'select', value: '', data: [
                { value: 'Free', placeholder: 'Free' },
                { value: 'Discount', placeholder: 'Discount' },
            ]
        },
        {
            label: 'Advertisement Type', placeholder: 'Select Advertisement Type', name: 'advertisementType', value: '', type: 'select', data: [
                { value: 'Scroll Ads', placeholder: 'Scroll Ads' },
                { value: 'Sticky Ads', placeholder: 'Sticky Ads' },
                { value: 'Banner', placeholder: 'Banner' },
                { value: 'Video', placeholder: 'Video' },
                { value: 'Native', placeholder: 'Native' },
                { value: 'Pop-Up Ads', placeholder: 'Pop-Up Ads' },
                { value: 'Sponsored Content', placeholder: 'Sponsored Content' },
                { value: 'Carousel', placeholder: 'Carousel' },
                { value: 'Reward Based Ad', placeholder: 'Reward Based Ad' },
                { value: 'Interactive Ads', placeholder: 'Interactive Ads' },
            ]
        },
        { label: 'Advertisement Details', placeholder: 'Enter Advertisement Details', name: 'advertisementDetails', value: '', type: 'textarea', data: [] },
        {
            label: 'Preferred Placement Slot', placeholder: 'Select Preferred Placement Slot', name: 'preferredPlacementSlot', value: '', type: 'select', data: [
                { value: 'knowledge-board-videos', placeholder: 'Knowledge Board - Videos' },
                { value: 'knowledge-board-tips', placeholder: 'Knowledge Board - Tips' },
                { value: 'knowledge-board-news', placeholder: 'Knowledge Board - News' },
                { value: 'new-challenges', placeholder: 'New Challenges' },
                { value: 'eco-activities', placeholder: 'Eco Activities' },
                { value: 'blogs', placeholder: 'Blogs' },
                { value: 'events', placeholder: 'Events' },
                { value: 'challenges-homepage', placeholder: 'Challenges Homepage' },
            ]
        },
        { label: 'Brand Message', placeholder: 'Select Brand Message (for display in App)', name: 'brandMessage', value: '', type: 'textarea' },
    ];

    const projectPromotion = [
        {
            label: 'Category of Projects', placeholder: 'Selct Category of Projects', name: 'categoryOfProjects', type: 'select', value: '', data: [
                { value: 'Reforestation', placeholder: 'Reforestation' },
                { value: 'Renewable', placeholder: 'Renewable' },
                { value: 'Waste Mgmt', placeholder: 'Waste Mgmt' },
                { value: 'Biochar', placeholder: 'Biochar' },
                { value: 'Water Conservation', placeholder: 'Water Conservation' },
                { value: 'Other', placeholder: 'Other' },
            ]
        },
        { label: 'Number of Projects', placeholder: 'Enter Number of Projects', name: 'numberOfProjects', type: 'number', value: '', data: [] },
        { label: 'Location of Projects', placeholder: 'Enter Location of Projects', name: 'locationOfProjects', type: 'text', value: '', data: [] },
        { label: 'Details of Projects', placeholder: 'Enter Details of Projects', name: 'detailsOfProjects', type: 'text', value: '', data: [] },
        { label: 'Fund Raise Target', placeholder: 'Enter Fund Raise Target', name: 'fundRaiseTarget', type: 'number', value: '', data: [] },
        { label: 'Platform Fee agreement', placeholder: 'Enter Platform Fee agreement', name: 'platformFeeAgreement', type: 'checkbox', value: '', data: [] },
        { label: 'Developer Message', placeholder: 'Enter Developer Message (for display in App)', name: 'developerMessage', type: 'textarea', value: '', data: [] },
    ];

    const csrDonation = [
        {
            label: 'Category of Projects Preferred', placeholder: 'Selct Category of Projects Preferred', name: 'categoryOfProjectsPreferred', type: 'select', value: '', data: [
                { value: 'Reforestation', placeholder: 'Reforestation' },
                { value: 'Renewable', placeholder: 'Renewable' },
                { value: 'Waste Management', placeholder: 'Waste Management' },
                { value: 'Biochar', placeholder: 'Biochar' },
                { value: 'Water Conservation', placeholder: 'Water Conservation' },
                { value: 'Other', placeholder: 'Other' },
            ]
        },
        { label: 'Donation Matching Ratio', placeholder: 'Enter Donation Matching Ratio (1:5, 1:10 etc)', name: 'donationMatchingRatio', type: 'text', value: '', data: [] },
        { label: 'Details of Projects Preferred', placeholder: 'Enter Details of Projects Preferred', name: 'detailsOfProjectsPreferred', type: 'textarea', value: '', data: [] },
        { label: 'Details of CSR/ESG Goals', placeholder: 'Enter Details of CSR/ESG Goals', name: 'detailsOfCSRESGGoals', type: 'textarea', value: '', data: [] },
        { label: 'Details about Donation Budget', placeholder: 'Enter Details about Donation Budget', name: 'detailsAboutDonationBudget', type: 'textarea', value: '', data: [] },
        { label: 'Donor Message', placeholder: 'Enter Donor Message (for display in App)', name: 'donorMessage', type: 'textarea', value: '', data: [] },
    ];

    const advertiser = [
        {
            label: 'Advertisement Commodity', placeholder: 'Selct Advertisement Commodity', name: 'advertisementCommodity', type: 'select', value: '', data: [
                { value: 'Product', placeholder: 'Product' },
                { value: 'Service', placeholder: 'Service' },
                { value: 'Both', placeholder: 'Both' },
            ]
        },
        {
            label: 'AdvAdvertisement Goal', placeholder: 'Selct AdvAdvertisement Goal', name: 'advertisementGoal', type: 'select', value: '', data: [
                { value: 'Brand Awareness', placeholder: 'Brand Awareness' },
                { value: 'Lead Generation', placeholder: 'Lead Generation' },
                { value: 'Promotion', placeholder: 'Promotion' },
                { value: 'Sales', placeholder: 'Sales' },
            ]
        },
        {
            label: 'Advertisement Type', placeholder: 'Select Advertisement Type', name: 'advertisementType', type: 'select', value: '', data: [
                { value: 'Scroll Ads', placeholder: 'Scroll Ads' },
                { value: 'Sticky Ads', placeholder: 'Sticky Ads' },
                { value: 'Banner', placeholder: 'Banner' },
                { value: 'Video', placeholder: 'Video' },
                { value: 'Native', placeholder: 'Native' },
                { value: 'Pop-Up Ads', placeholder: 'Pop-Up Ads' },
                { value: 'Sponsored Content', placeholder: 'Sponsored Content' },
                { value: 'Carousel', placeholder: 'Carousel' },
                { value: 'Reward Based Ad', placeholder: 'Reward Based Ad' },
                { value: 'Interactive Ads', placeholder: 'Interactive Ads' },
            ]
        },
        {
            label: 'Preferred Placement Slot', placeholder: 'Select Preferred Placement Slot', name: 'preferredPlacementSlot', type: 'select', value: '', data: [
                { value: 'knowledge-board-videos', placeholder: 'Knowledge Board - Videos' },
                { value: 'knowledge-board-tips', placeholder: 'Knowledge Board - Tips' },
                { value: 'knowledge-board-news', placeholder: 'Knowledge Board - News' },
                { value: 'new-challenges', placeholder: 'New Challenges' },
                { value: 'eco-activities', placeholder: 'Eco Activities' },
                { value: 'blogs', placeholder: 'Blogs' },
                { value: 'events', placeholder: 'Events' },
                { value: 'challenges-homepage', placeholder: 'Challenges Homepage' },
            ]
        },
        { label: 'Advertisement Details', placeholder: 'Enter Advertisement Details: Brief description of the ad content, target audience, and call-to-action.', name: 'advertisementDetails', type: 'textarea', value: '', data: [] },
        { label: 'Advertisement Budget:', placeholder: 'Enter Advertisement Budget', name: 'advertisementBudget', type: 'number', value: '', data: [] },
        {
            label: 'Target Demographics criteria', placeholder: 'Select Target Demographics criteria', name: 'targetDemographicsCriteria', type: 'select', value: '', data: [
                { value: 'Age Group', placeholder: 'Age Group' },
                { value: 'Gender', placeholder: 'Gender' },
                { value: 'Location', placeholder: 'Location' },
                { value: 'Interests', placeholder: 'Interests' },
            ]
        },
        { label: 'Target Demographic Values', placeholder: 'Enter Target Demographic Values', name: 'targetDemographicValues', type: 'textarea', value: '', data: [] },];

    const targetUserFields = [
        { label: 'Brand Awareness', placeholder: 'Enter Brand Awareness', name: 'brandAwareness', value: '' },
        { label: 'Lead Generation', placeholder: 'Enter Lead Generation', name: 'leadGeneration', value: '' },
        { label: 'CSR', placeholder: 'Enter CSR', name: 'csr', value: '' },
        { label: 'ESG', placeholder: 'Enter ESG', name: 'esg', value: '' },
    ];

    const financialFields = [
        { label: 'Bank Account Details', placeholder: 'Enter Bank Account Details', name: 'bankAccountDetails', value: '' },
        { label: 'Payment Terms', placeholder: 'Enter Payment Terms', name: 'paymentTerms', value: '' },
        { label: 'Agreement On Revenue Share Or Commission Rates', placeholder: 'Enter Agreement On Revenue Share Or Commission Rates', name: 'agreementOnRevenueShareOrCommissionRates', value: '' },
    ];

    const impactFields = [
        {
            label: 'Metrices', placeholder: 'Select Metrices', name: 'metricsDataPoints', value: '', type: 'multiselect', data: [
                { value: 'Total Carbon Savings', label: 'Total Carbon Savings' },
                { value: 'Total Revenue Generated', label: 'Total Revenue Generated' },
                { value: 'Conversion Rate', label: 'Conversion Rate' },
                { value: 'Total Impressions', label: 'Total Impressions' },
                { value: 'Unique Impressions', label: 'Unique Impressions' },
                { value: 'Total Clicks', label: 'Total Clicks' },
                { value: 'Unique Clicks', label: 'Unique Clicks' },
                { value: 'Total Trees Planted', label: 'Total Trees Planted' },
                { value: 'Total Volunteers', label: 'Total Volunteers' },
                { value: 'Total Certificates Issued', label: 'Total Certificates Issued' },
            ]
        },
        {
            label: 'Reporting Frequency', placeholder: 'Enter Reporting Frequency', name: 'reportingFrequency', value: '', type: 'select', data: [
                { value: 'Daily', placeholder: 'Daily' },
                { value: 'Weekly', placeholder: 'Weekly' },
                { value: 'Monthly', placeholder: 'Monthly' },
                { value: 'Quarterly', placeholder: 'Quarterly' },
                { value: 'Yearly', placeholder: 'Yearly' },
            ]
        },
        { label: 'A Short Paragraph On The Sponsor Company', placeholder: 'Write A Short Paragraph On The Sponsor Company', name: 'aShortParagraphOnTheSponsorCompany', value: '' },
        { label: 'Reporting Goals', placeholder: 'Write Reporting Goals', name: 'reportingGoals', value: '' },
        { label: 'Remarks/Notes', placeholder: 'Enter Remarks/Notes', name: 'remarksOrNotes', value: '' },
        { label: 'Attachments', placeholder: 'Enter Attachments', name: 'attachments', value: [] },
    ];

    const [image, setImage] = React.useState(null);
    const [active, setActive] = React.useState(false);

    // const validateForm = () => {
    //     const newErrors = ;
    //     if (!formData.companyName) newErrors.companyName = "Company name is required";
    //     if (!formData.email) newErrors.email = "Email is required";
    //     if (!formData.phoneNumber) newErrors.phoneNumber = "Phone number is required";

    //     return Object.keys(newErrors).length === 0;
    // };

    const onSubmit = async (data, sendCredentials = false) => {
        // Structure the payload according to the company schema
        const processedData = {
            // Basic company information
            companyName: data.companyName || '',
            industryOrSector: data.industryOrSector || '',
            description: data.description || '',
            branchAddress: data.branchAddress || '',
            phone: data.phone || '',
            email: data.email || '',
            headquarterAddress: data.headquarterAddress || '',
            websiteUrl: data.websiteUrl || '',
            registrationNumber: data.registrationNumber || '',
            taxIdentificationNumber: data.taxIdentificationNumber || '',
            logo: image || '',
            active: active,
            sendCredentials: sendCredentials,
            isImagePresent: image && typeof image === 'object' && image instanceof File,

            // Social Links
            socialLinks: {
                linkedIn: data.linkedIn || '',
                instagram: data.instagram || '',
                facebook: data.facebook || '',
                twitter: data.twitter || '',
                youtube: data.youtube || '',
            },

            // Account Details
            accountDetails: {
                username: data.username || '',
                password: data.password || '',
                displayName: data.displayName || '',
                emails: data.emailRecipients
                    ? data.emailRecipients.split(',').map(email => email.trim()).filter(email => email.length > 0)
                    : []
            },

            // Point of Contact
            pointOfContact: {
                pocName: data.pocName || '',
                pocDesignation: data.pocDesignation || '',
                pocDepartment: data.pocDepartment || '',
                pocPhone: data.pocPhone || '',
                pocMobile: data.pocMobile || '',
                pocEmail: data.pocEmail || '',
            },

            // Partnership Details
            partnershipDetails: {
                typeOfPartnership: Array.isArray(data.typeOfPartnership)
                    ? data.typeOfPartnership.map(item => typeof item === 'object' ? item.value : item)
                    : [],
                partnershipObjective: data.partnershipObjective || '',
                partnershipStartDate: data.partnershipStartDate || '',
                categoryOfChallengePreferred: data.categoryOfChallengePreferred || '',
                rewardsOffered: data.rewardsOffered || '',
                rewardsMode: data.rewardsMode || '',
                advertisementType: data.advertisementType || '',
                preferredPlacementSlot: data.preferredPlacementSlot || '',
                advertisementDetails: data.advertisementDetails || '',
                sponsorMessage: data.sponsorMessage || '',
                numberOfProductsOnOffer: data.numberOfProductsOnOffer || '',
                typeOfProductsOnOffer: data.typeOfProductsOnOffer || '',
                priceRangeOfProductsOnOffer: data.priceRangeOfProductsOnOffer || '',
                detailsOfDonationPreference: data.detailsOfDonationPreference || '',
                detailsOfSpecificProjects: data.detailsOfSpecificProjects || '',
                detailsOfCSRGoals: data.detailsOfCSRGoals || '',
            },

            // Brand Promotion
            brandPromotion: {
                categoryOfProducts: data.categoryOfProducts || '',
                priceRangeOfProducts: data.priceRangeOfProducts || '',
                detailsOfProducts: data.detailsOfProducts || '',
                offerType: data.offerType || '',
                advertisementType: data.brandPromotionAdvertisementType || '',
                advertisementDetails: data.brandPromotionAdvertisementDetails || '',
                preferredPlacementSlot: data.brandPromotionPreferredPlacementSlot || '',
                brandMessage: data.brandMessage || '',
            },

            // Project Promotion
            projectPromotion: {
                categoryOfProjects: data.categoryOfProjects || '',
                numberOfProjects: data.numberOfProjects || '',
                locationOfProjects: data.locationOfProjects || '',
                detailsOfProjects: data.detailsOfProjects || '',
                fundRaiseTarget: data.fundRaiseTarget || '',
                platformFeeAgreement: data.platformFeeAgreement || '',
                developerMessage: data.developerMessage || '',
            },

            // CSR Donation
            csrDonation: {
                categoryOfProjectsPreferred: data.categoryOfProjectsPreferred || '',
                donationMatchingRatio: data.donationMatchingRatio || '',
                detailsOfProjectsPreferred: data.detailsOfProjectsPreferred || '',
                detailsOfCSRESGGoals: data.detailsOfCSRESGGoals || '',
                detailsAboutDonationBudget: data.detailsAboutDonationBudget || '',
                donorMessage: data.donorMessage || '',
            },

            // Advertiser
            advertiser: {
                advertisementCommodity: data.advertisementCommodity || '',
                advertisementGoal: data.advertisementGoal || '',
                advertiserAdvertisementType: data.advertiserAdvertisementType || '',
                advertiserPreferredPlacementSlot: data.advertiserPreferredPlacementSlot || '',
                advertiserAdvertisementDetails: data.advertiserAdvertisementDetails || '',
                advertisementBudget: data.advertisementBudget || '',
                targetDemographicsCriteria: data.targetDemographicsCriteria || '',
                targetDemographicValues: data.targetDemographicValues || '',
            },

            // Target User Age Group Partnership Objectives
            targetUserAgeGroupPartnershipObjectives: {
                brandAwareness: data.brandAwareness || '',
                leadGeneration: data.leadGeneration || '',
                csr: data.csr || '',
                esg: data.esg || '',
            },

            // Compliance and Agreements
            complianceAndAgreements: {
                agreements: data.complianceAndAgreements?.agreements || [],
                dataPrivacyComplianceAcknowledgement: data.complianceAndAgreements?.dataPrivacyComplianceAcknowledgement || '',
            },

            // Financial Details
            financialDetails: {
                bankAccountDetails: data.bankAccountDetails || '',
                paymentTerms: data.paymentTerms || '',
                agreementOnRevenueShareOrCommissionRates: data.agreementOnRevenueShareOrCommissionRates || '',
            },

            // Impact and Reporting
            impactAndReporting: {
                metricsDataPoints: Array.isArray(data.metricsDataPoints) ? data.metricsDataPoints.join(', ') : (data.metricsDataPoints || ''),
                reportingFrequency: data.reportingFrequency || '',
                aShortParagraphOnTheSponsorCompany: data.aShortParagraphOnTheSponsorCompany || '',
                reportingGoals: data.reportingGoals || '',
                remarksOrNotes: data.remarksOrNotes || '',
                attachments: data.attachments || [],
            },

            // Show in Homepage
            showInHomepage: data.showInHomepage || false,
            newComplianceDocuments: data.newComplianceDocuments || [],
        };

        // Normalize file upload objects for the doc service
        if (Array.isArray(processedData.newComplianceDocuments) && processedData.newComplianceDocuments.length > 0) {
            processedData.newComplianceDocuments = processedData.newComplianceDocuments.map(doc => ({
                ...doc,
                file: doc.base64 || doc.file || doc.content || '',
                content: doc.base64 || doc.file || doc.content || ''
            }));
        }

        // As a safety measure, set userType
        processedData.userType = 'company';

        // If sendCredentials is true, validate account details fields
        if (sendCredentials) {
            const accountErrors = {};

            // Check username
            if (!data.username || data.username.trim() === '') {
                accountErrors.username = 'Username is required';
            } else if (data.username.length < 3) {
                accountErrors.username = 'Username must be at least 3 characters';
            }

            // // display name is optional now
            // if (!data.displayName || data.displayName.trim() === '') {
            //     accountErrors.displayName = 'Display Name is required';
            // } else if (data.displayName.length < 2) {
            //     accountErrors.displayName = 'Display name must be at least 2 characters';
            // }

            // Check email recipients
            if (!data.emailRecipients || data.emailRecipients.trim() === '') {
                accountErrors.emailRecipients = 'Email recipients are required';
            } else {
                // Validate email format
                const emails = data.emailRecipients.split(',').map(email => email.trim());
                const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                const invalidEmails = emails.filter(email => email && !emailRegex.test(email));
                if (invalidEmails.length > 0) {
                    accountErrors.emailRecipients = `Invalid email format: ${invalidEmails.join(', ')}`;
                }
            }

            // If there are validation errors, set them and return
            if (Object.keys(accountErrors).length > 0) {
                // Set errors for each field
                Object.keys(accountErrors).forEach(field => {
                    setError(field, {
                        type: 'manual',
                        message: accountErrors[field]
                    });
                });

                // Show a toast message with specific error details
                toast.error('All Account Details fields are mandatory for sending credentials. Please fill all required fields correctly.');
                return;
            }

            // Clear any existing errors
            clearErrors(['username', /*'displayName',*/ 'emailRecipients']);
        }

        console.log('Form data structured according to schema:', processedData);
        console.debug('Submitting Company (onSubmit) - newComplianceDocuments keys:', processedData.newComplianceDocuments?.map(doc => Object.keys(doc)));

        // Use the same API endpoint for both save and save+register
        // The sendCredentials field in the payload will tell the backend whether to send credentials
        try {
            if (companyId) {
                await updateCompany(
                    companyId,
                    processedData,
                    image,
                    navigate,
                    toast
                );
            } else {
                await createCompany(
                    processedData,
                    image,
                    navigate,
                    toast
                );
            }
        } catch (error) {
            console.error('Error saving company:', error);
            toast.error('Failed to save company. Please try again.');
        }
    };

    // Handle Save button - calls onSubmit with sendCredentials = false
    const handleSave = () => {
        handleSubmit((data) => onSubmit(data, false))();
    };

    // Handle Save and Register button - calls onSubmit with sendCredentials = true
    const handleSaveAndRegister = () => {
        handleSubmit((data) => onSubmit(data, true))();
    };

    React.useEffect(() => {
        if (data) {
            console.log('Loading company data for editing:', data);
            // Company Information
            setValue('companyName', data.companyName || '');
            setValue('industryOrSector', data.industryOrSector || '');
            setValue('description', data.description || '');
            setValue('branchAddress', data.branchAddress || '');
            setValue('phone', data.phone || '');
            setValue('email', data.email || '');
            setValue('headquarterAddress', data.headquarterAddress || '');
            setValue('websiteUrl', data.websiteUrl || '');
            setValue('registrationNumber', data.registrationNumber || '');
            setValue('taxIdentificationNumber', data.taxIdentificationNumber || '');

            // Social Media Details
            if (data.socialLinks) {
                setValue('linkedIn', data.socialLinks.linkedIn || '');
                setValue('instagram', data.socialLinks.instagram || '');
                setValue('facebook', data.socialLinks.facebook || '');
                setValue('twitter', data.socialLinks.twitter || '');
                setValue('youtube', data.socialLinks.youtube || '');
            }

            // Account Details
            if (data.accountDetails) {
                setValue('username', data.accountDetails.username || '');
                // setValue('password', data.accountDetails.password || '');
                setValue('displayName', data.accountDetails.displayName || '');
                // Convert emails array to comma-separated string
                setValue('emailRecipients', data.accountDetails.emails ? data.accountDetails.emails.join(', ') : '');
            }

            // Point of Contact
            if (data.pointOfContact) {
                setValue('pocName', data.pointOfContact.pocName || '');
                setValue('pocDesignation', data.pointOfContact.pocDesignation || '');
                setValue('pocDepartment', data.pointOfContact.pocDepartment || '');
                setValue('pocPhone', data.pointOfContact.pocPhone || '');
                setValue('pocMobile', data.pointOfContact.pocMobile || '');
                setValue('pocEmail', data.pointOfContact.pocEmail || '');
            }

            // Partnership Details
            if (data.partnershipDetails) {
                // Handle typeOfPartnership - convert array of strings to array of objects for the dropdown
                const typeOfPartnershipOptions = (data.partnershipDetails.typeOfPartnership || []).map(value => ({
                    value: value,
                    label: value
                }));
                setValue('typeOfPartnership', typeOfPartnershipOptions);
                
                setValue('partnershipObjective', data.partnershipDetails.partnershipObjective || '');
                
                // Handle partnershipStartDate - format datetime for input field
                if (data.partnershipDetails.partnershipStartDate) {
                    const dateValue = new Date(data.partnershipDetails.partnershipStartDate);
                    const formattedDate = dateValue.toISOString().split('T')[0]; // Format to YYYY-MM-DD for date input
                    setValue('partnershipStartDate', formattedDate);
                } else {
                    setValue('partnershipStartDate', '');
                }
                setValue('categoryOfChallengePreferred', data.partnershipDetails.categoryOfChallengePreferred || '');
                setValue('rewardsOffered', data.partnershipDetails.rewardsOffered || '');
                setValue('rewardsMode', data.partnershipDetails.rewardsMode || '');
                setValue('advertisementType', data.partnershipDetails.advertisementType || '');
                setValue('preferredPlacementSlot', data.partnershipDetails.preferredPlacementSlot || '');
                setValue('advertisementDetails', data.partnershipDetails.advertisementDetails || '');
                setValue('sponsorMessage', data.partnershipDetails.sponsorMessage || '');
                setValue('numberOfProductsOnOffer', data.partnershipDetails.numberOfProductsOnOffer || '');
                setValue('typeOfProductsOnOffer', data.partnershipDetails.typeOfProductsOnOffer || '');
                setValue('priceRangeOfProductsOnOffer', data.partnershipDetails.priceRangeOfProductsOnOffer || '');
                setValue('detailsOfDonationPreference', data.partnershipDetails.detailsOfDonationPreference || '');
                setValue('detailsOfSpecificProjects', data.partnershipDetails.detailsOfSpecificProjects || '');
                setValue('detailsOfCSRGoals', data.partnershipDetails.detailsOfCSRGoals || '');
            }

            // Brand Promotion
            if (data.brandPromotion) {
                setValue('categoryOfProducts', data.brandPromotion.categoryOfProducts || '');
                setValue('priceRangeOfProducts', data.brandPromotion.priceRangeOfProducts || '');
                setValue('detailsOfProducts', data.brandPromotion.detailsOfProducts || '');
                setValue('offerType', data.brandPromotion.offerType || '');
                setValue('brandPromotionAdvertisementType', data.brandPromotion.advertisementType || '');
                setValue('brandPromotionAdvertisementDetails', data.brandPromotion.advertisementDetails || '');
                setValue('brandPromotionPreferredPlacementSlot', data.brandPromotion.preferredPlacementSlot || '');
                setValue('brandMessage', data.brandPromotion.brandMessage || '');
            }

            // Project Promotion
            if (data.projectPromotion) {
                setValue('categoryOfProjects', data.projectPromotion.categoryOfProjects || '');
                setValue('numberOfProjects', data.projectPromotion.numberOfProjects || '');
                setValue('locationOfProjects', data.projectPromotion.locationOfProjects || '');
                setValue('detailsOfProjects', data.projectPromotion.detailsOfProjects || '');
                setValue('fundRaiseTarget', data.projectPromotion.fundRaiseTarget || '');
                setValue('platformFeeAgreement', data.projectPromotion.platformFeeAgreement || '');
                setValue('developerMessage', data.projectPromotion.developerMessage || '');
            }

            // CSR/ESG Donation
            if (data.csrDonation) {
                setValue('categoryOfProjectsPreferred', data.csrDonation.categoryOfProjectsPreferred || '');
                setValue('donationMatchingRatio', data.csrDonation.donationMatchingRatio || '');
                setValue('detailsOfProjectsPreferred', data.csrDonation.detailsOfProjectsPreferred || '');
                setValue('detailsOfCSRESGGoals', data.csrDonation.detailsOfCSRESGGoals || '');
                setValue('detailsAboutDonationBudget', data.csrDonation.detailsAboutDonationBudget || '');
                setValue('donorMessage', data.csrDonation.donorMessage || '');
            }

            // Advertiser
            if (data.advertiser) {
                setValue('advertisementCommodity', data.advertiser.advertisementCommodity || '');
                setValue('advertisementGoal', data.advertiser.advertisementGoal || '');
                setValue('advertiserAdvertisementType', data.advertiser.advertiserAdvertisementType || '');
                setValue('advertiserPreferredPlacementSlot', data.advertiser.advertiserPreferredPlacementSlot || '');
                setValue('advertiserAdvertisementDetails', data.advertiser.advertiserAdvertisementDetails || '');
                setValue('advertisementBudget', data.advertiser.advertisementBudget || '');
                setValue('targetDemographicsCriteria', data.advertiser.targetDemographicsCriteria || '');
                setValue('targetDemographicValues', data.advertiser.targetDemographicValues || '');
            }

            // Target User Age Group Partnership Objectives
            if (data.targetUserAgeGroupPartnershipObjectives) {
                setValue('brandAwareness', data.targetUserAgeGroupPartnershipObjectives.brandAwareness || '');
                setValue('leadGeneration', data.targetUserAgeGroupPartnershipObjectives.leadGeneration || '');
                setValue('csr', data.targetUserAgeGroupPartnershipObjectives.csr || '');
                setValue('esg', data.targetUserAgeGroupPartnershipObjectives.esg || '');
            }

            // Financial Details
            if (data.financialDetails) {
                setValue('bankAccountDetails', data.financialDetails.bankAccountDetails || '');
                setValue('paymentTerms', data.financialDetails.paymentTerms || '');
                setValue('agreementOnRevenueShareOrCommissionRates', data.financialDetails.agreementOnRevenueShareOrCommissionRates || '');
            }

            // Impact and Reporting
            if (data.impactAndReporting) {
                const metrics = data.impactAndReporting.metricsDataPoints;
                setValue('metricsDataPoints', Array.isArray(metrics) ? metrics : (typeof metrics === 'string' && metrics ? metrics.split(', ').map(s => s.trim()).filter(Boolean) : []));
                setValue('reportingFrequency', data.impactAndReporting.reportingFrequency || '');
                setValue('aShortParagraphOnTheSponsorCompany', data.impactAndReporting.aShortParagraphOnTheSponsorCompany || '');
                setValue('reportingGoals', data.impactAndReporting.reportingGoals || '');
                setValue('remarksOrNotes', data.impactAndReporting.remarksOrNotes || '');
            }

            // Compliance and Agreements
            if (data.complianceAndAgreements) {
                setValue('complianceAndAgreements.agreements', data.complianceAndAgreements.agreements || []);
                setValue('complianceAndAgreements.dataPrivacyComplianceAcknowledgement', data.complianceAndAgreements.dataPrivacyComplianceAcknowledgement || '');
            }

            // Show in Homepage
            setValue('showInHomepage', data.showInHomepage || false);

            // Set active status
            if (typeof data.active !== 'undefined') {
                setActive(data.active);
            }

            console.log('All form values set successfully');
        }
    }, [data, setValue]);

    React.useEffect(() => {
        if (data?.logo) {
            setTimeout(() => {
                setImage(data?.logo);
            }, 200);
        }
    }, [data]);

    if (isLoading) {
        return (
            <div>
                Loading...
            </div>
        );
    }

    return (
        <form className="flex flex-col" noValidate onSubmit={(e) => { e.preventDefault(); }}>
            <div className="flex items-center justify-between mb-4">
                <Heading
                    text={"Company Creation Form"}
                />
                <ActiveStatus
                    active={active}
                    setActive={setActive}
                    isCreateForm={true}
                    label="Status"
                    innerActiveText="Active"
                    innerInactiveText="Inactive"
                />
            </div>

            <FormSection title="Basic Details 1">
                <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
                    <div className="flex flex-col gap-3 grow shrink text-sm min-w-[240px] w-[844px] max-md:max-w-full">
                        <div className="flex gap-3 items-center w-full">
                            <div className="flex flex-col flex-grow w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[0].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[0].placeholder}
                                        {...register(formData[0].name, {
                                            required: `${formData[0].label} is required`
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[0].name] ? "border-red" : ""}`}
                                    />
                                </div>
                                {errors[formData[0].name] && <p className="text-red text-sm">{errors[formData[0].name].message}</p>}
                            </div>
                            <div className="flex flex-col flex-grow w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[1].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[1].placeholder}
                                        {...register(formData[1].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[1].name] ? "border-red" : ""}`}
                                    />
                                </div>
                                {errors[formData[1].name] && <p className="text-red text-sm">{errors[formData[1].name].message}</p>}
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[4].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="tel"
                                        placeholder={formData[4].placeholder}
                                        {...register(formData[4].name, {
                                            required: `${formData[4].label} is required`,
                                            pattern: {
                                                value: /^[+]?[\d\s\-\(\)]+$/,
                                                message: "Please enter a valid phone number"
                                            }
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[4].name] ? "border-red" : ""}`}
                                    />
                                </div>
                                {errors[formData[4].name] && <p className="text-red text-sm">{errors[formData[4].name].message}</p>}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[5].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="email"
                                        placeholder={formData[5].placeholder}
                                        {...register(formData[5].name, {
                                            required: `${formData[5].label} is required`,
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Please enter a valid email address"
                                            }
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[5].name] ? "border-red" : ""}`}
                                    />
                                </div>
                                {errors[formData[5].name] && <p className="text-red text-sm">{errors[formData[5].name].message}</p>}
                            </div>
                        </div>
                        <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                <span className="text-red text-xs inline">*</span> {formData[3].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <textarea
                                    type="text"
                                    placeholder={formData[3].placeholder}
                                    {...register(formData[3].name, {
                                        required: `${formData[3].label} is required`
                                    })}
                                    className={`flex-1 shrink self-stretch min-h-[100px] my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[3].name] ? "border-red" : ""}`}
                                />
                            </div>
                            {errors[formData[3].name] && <p className="text-red text-sm">{errors[formData[3].name].message}</p>}
                        </div>

                    </div>
                    {/* <ImageInput
                        image={image}
                        setImage={setImage}
                        text={'Company Logo'}
                    /> */}
                    <div className="mb-8 -mt-2">
                        <MediaUpload
                            existingImage={image}
                            stateImage={image}
                            setImageUpload={setImage}
                            setStateImageUpload={setImage}
                            label="logo"
                            useFileObject={true}
                        />
                    </div>
                </div>


                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {formData[6].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <input
                            type="text"
                            placeholder={formData[6].placeholder}
                            {...register(formData[6].name, {
                                // required: `${formData[6].label} is required`
                            })}
                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[6].name] ? "border-red" : ""}`}
                        />
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {formData[7].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={formData[7].placeholder}
                                {...register(formData[7].name, {
                                    // required: `${formData[7].label} is required`,
                                    pattern: {
                                        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w\.\-\~\:\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\%]*)*\/?$/i,
                                        message: "Please enter a valid URL"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[7].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {formData[8].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={formData[8].placeholder}
                                {...register(formData[8].name, {
                                    // required: `${formData[8].label} is required`
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[8].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {formData[9].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={formData[9].placeholder}
                                {...register(formData[9].name, {
                                    // required: `${formData[9].label} is required`
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[9].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <FormSection title="Social Media Details" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[0].placeholder}
                                {...register(socialFields[0].name, {
                                    pattern: {
                                        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w\.\-\~\:\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\%]*)*\/?$/i,
                                        message: "Please enter a valid URL"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[socialFields[0].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[socialFields[0].name] && <p className="text-red text-sm">{errors[socialFields[0].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[1].placeholder}
                                {...register(socialFields[1].name, {
                                    pattern: {
                                        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w\.\-\~\:\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\%]*)*\/?$/i,
                                        message: "Please enter a valid URL"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[socialFields[1].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[socialFields[1].name] && <p className="text-red text-sm">{errors[socialFields[1].name].message}</p>}
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[2].placeholder}
                                {...register(socialFields[2].name, {
                                    pattern: {
                                        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w\.\-\~\:\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\%]*)*\/?$/i,
                                        message: "Please enter a valid URL"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[socialFields[2].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[socialFields[2].name] && <p className="text-red text-sm">{errors[socialFields[2].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[3].placeholder}
                                {...register(socialFields[3].name, {
                                    pattern: {
                                        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w\.\-\~\:\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\%]*)*\/?$/i,
                                        message: "Please enter a valid URL"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[socialFields[3].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[socialFields[3].name] && <p className="text-red text-sm">{errors[socialFields[3].name].message}</p>}
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[4].placeholder}
                                {...register(socialFields[4].name, {
                                    pattern: {
                                        value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,})([\/\w\.\-\~\:\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\%]*)*\/?$/i,
                                        message: "Please enter a valid URL"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[socialFields[4].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[socialFields[4].name] && <p className="text-red text-sm">{errors[socialFields[4].name].message}</p>}
                    </div>
                </div>
            </FormSection>

            <FormSection title="Account Details" defaultExpanded={false}>
                <p>*Note: Password will be auto generated from the system</p>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {/* <span className="text-red text-xs inline">*</span>  */}
                            {accountFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[0].placeholder}
                                {...register(accountFields[0].name, {
                                    // required: `${accountFields[0].label} is required`,
                                    minLength: {
                                        value: 3,
                                        message: "Username must be at least 3 characters"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[0].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[accountFields[0].name] && <p className="text-red text-sm">{errors[accountFields[0].name].message}</p>}
                    </div>
                    {/* <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            <span className="text-red text-xs inline">*</span> 
                            {accountFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[1].placeholder}
                                {...register(accountFields[1].name, {
                                    // required: `${accountFields[1].label} is required`,
                                    minLength: {
                                        value: 8,
                                        message: "Password must be at least 8 characters"
                                    },
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
                                        message: "Password must contain at least one uppercase, one lowercase, one number and one special character"
                                    }
                                })}
                                // disabled={companyId ? true : false}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[1].name] ? "border-red" : ""} ${companyId ? `cursor-not-allowed` : ``}`}
                            />
                        </div>
                        {errors[accountFields[1].name] && <p className="text-red text-sm">{errors[accountFields[1].name].message}</p>}
                    </div> */}
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {/* <span className="text-red text-xs inline">*</span>  */}
                            {accountFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[1].placeholder}
                                {...register(accountFields[1].name, {
                                    // required: `${accountFields[2].label} is required`,
                                    minLength: {
                                        value: 2,
                                        message: "Display name must be at least 2 characters"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[1].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[accountFields[1].name] && <p className="text-red text-sm">{errors[accountFields[1].name].message}</p>}
                    </div>
                </div>
                <div class="flex gap-1">
                    <div className="flex flex-col shrink-0 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {/* <span className="text-red text-xs inline">*</span>  */}
                            {accountFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[2].placeholder}
                                {...register(accountFields[2].name, {
                                    // required: `${accountFields[3].label} is required`,
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[2].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[accountFields[2].name] && <p className="text-red text-sm">{errors[accountFields[2].name].message}</p>}
                    </div>
                </div>
            </FormSection>

            <FormSection title="Point Of Contact" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={pocFields[0].placeholder}
                                {...register(pocFields[0].name, {
                                    // required: 'POC name is required.'
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[0].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={pocFields[1].placeholder}
                                {...register(pocFields[1].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[1].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={pocFields[2].placeholder}
                                {...register(pocFields[2].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[2].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="tel"
                                placeholder={pocFields[3].placeholder}
                                {...register(pocFields[3].name, {
                                    pattern: {
                                        value: /^[+]?[\d\s\-\(\)]+$/,
                                        message: "Please enter a valid phone number"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[3].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="tel"
                                placeholder={pocFields[4].placeholder}
                                {...register(pocFields[4].name, {
                                    pattern: {
                                        value: /^[+]?[\d\s\-\(\)]+$/,
                                        message: "Please enter a valid phone number"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[4].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[5].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="email"
                                placeholder={pocFields[5].placeholder}
                                {...register(pocFields[5].name, {
                                    // required: 'POC email is required!',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "Please enter a valid email address"
                                    }
                                })}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[5].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <FormSection title="Partnership Details" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {partnerFields[0].label}
                        </label>
                        <Select
                            options={partnerFields[0].data}
                            isMulti={true}
                            placeholder="Select type of partnership"
                            classNamePrefix="select"
                            className='mt-1 text-base'
                            value={watchedTypeOfPartnership}
                            isClearable
                            isSearchable
                            name={partnerFields[0].name}
                            onChange={(selectedOptions) => {
                                setValue('typeOfPartnership', selectedOptions || []);
                            }}
                            noOptionsMessage={() => "No data available"}
                            components={{
                                MultiValue: ({ children, ...props }) => (
                                    <div className="flex items-center gap-1 bg-green-50 rounded px-2 py-1 m-1">
                                        <span className="text-green-700">{children}</span>
                                        <button
                                            onClick={() => props.removeProps.onClick()}
                                            className="ml-1 text-green-600 hover:text-green-800"
                                        >
                                            ×
                                        </button>
                                    </div>
                                ),
                            }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    backgroundColor: 'transparent',
                                    border: `1px solid ${errors.eventsSection ? 'red' : 'rgba(224, 230, 237, 1)'}`,
                                    borderRadius: '0.375rem',
                                    boxShadow: state.isFocused ? (errors.eventsSection ? '0 0 0 1px red' : '0 0 0 1px #16ad3c') : 'none',
                                    padding: '0.15rem',
                                    ":hover": {
                                        borderColor: errors.eventsSection ? 'red' : '#16ad3c',
                                    },
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                                option: (base, { isSelected }) => ({
                                    ...base,
                                    backgroundColor: isSelected ? '#16ad3c' : 'white',
                                    color: isSelected ? 'white' : 'black',
                                    ":active": {
                                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)',
                                    },
                                    ":hover": {
                                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)',
                                    },
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(52, 199, 89, 0.1)',
                                    borderRadius: '4px',
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#16ad3c',
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#16ad3c',
                                    ':hover': {
                                        backgroundColor: 'rgba(52, 199, 89, 0.2)',
                                        color: '#16ad3c',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {partnerFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="date"
                                {...register(partnerFields[2].name,)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[partnerFields[2].name] ? "border-red" : ""}`}
                            />
                        </div>
                        {errors[partnerFields[2].name] && <p className="text-red text-sm">{errors[partnerFields[2].name].message}</p>}
                    </div>
                </div>
                <div className="flex gap-3" >
                    <div className="flex flex-col gap-1 basis-1/3">
                        <label className="text-[14px] font-[600] text-gray-900">
                            {partnerFields[8].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={partnerFields[8].placeholder}
                                {...register(partnerFields[8].name)}
                                className="w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 basis-1/3">
                        <label className="text-[14px] font-[600] text-gray-900">
                            {partnerFields[9].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={partnerFields[9].placeholder}
                                {...register(partnerFields[9].name)}
                                className="w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 basis-1/3">
                        <label className="text-[14px] font-[600] text-gray-900">
                            {partnerFields[13].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={partnerFields[13].placeholder}
                                {...register(partnerFields[13].name)}
                                className="w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col gap-1 basis-1/3">
                        <label className="text-[14px] font-[600] text-gray-900">
                            {partnerFields[14].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={partnerFields[14].placeholder}
                                {...register(partnerFields[14].name)}
                                className="w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 basis-1/3">
                        <label className="text-[14px] font-[600] text-gray-900">
                            {partnerFields[15].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={partnerFields[15].placeholder}
                                {...register(partnerFields[15].name)}
                                className="w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-1 basis-1/3">
                        <label className="text-[14px] font-[600] text-gray-900">
                            {formData[2].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={formData[2].placeholder}
                                {...register(formData[2].name, {
                                    // required: `${formData[2].label} is required`
                                })}
                                className={`w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn ${errors[formData[2].name] ? "border-red" : ""}`}
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            {/* Brand Promotion Section - Conditionally shown */}
            {watchedTypeOfPartnership && watchedTypeOfPartnership.some(item => item.value === 'Brand/Product Promotion') && (
                <FormSection title="Brand/Product Promotion Details" defaultExpanded={false}>
                    <div className="flex gap-3">
                        <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[0].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    {...register(brandPromotion[0].name)}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[0].name] ? "border-red" : ""}`}
                                >
                                    <option value="">Select {brandPromotion[0].label}</option>
                                    {brandPromotion[0].data.map((option) => (
                                        <option key={option.value} value={option.value}>{option.value}</option>
                                    ))}
                                </select>
                            </div>
                            {errors[brandPromotion[0].name] && <p className="text-red text-sm">{errors[brandPromotion[0].name].message}</p>}
                        </div>
                        <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[1].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    placeholder={brandPromotion[1].placeholder}
                                    {...register(brandPromotion[1].name)}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[1].name] ? "border-red" : ""}`}
                                />
                            </div>
                            {errors[brandPromotion[1].name] && <p className="text-red text-sm">{errors[brandPromotion[1].name].message}</p>}
                        </div>
                        <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[2].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    placeholder={brandPromotion[2].placeholder}
                                    {...register(brandPromotion[2].name)}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[2].name] ? "border-red" : ""}`}
                                />
                            </div>
                            {errors[brandPromotion[2].name] && <p className="text-red text-sm">{errors[brandPromotion[2].name].message}</p>}
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[3].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    {...register(brandPromotion[3].name)}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[3].name] ? "border-red" : ""}`}
                                >
                                    <option value="">Select {brandPromotion[3].label}</option>
                                    {brandPromotion[3].data.map((option) => (
                                        <option key={option.value} value={option.value}>{option.value}</option>
                                    ))}
                                </select>
                            </div>
                            {errors[brandPromotion[3].name] && <p className="text-red text-sm">{errors[brandPromotion[3].name].message}</p>}
                        </div>
                        <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[4].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    {...register(brandPromotion[4].name)}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[4].name] ? "border-red" : ""}`}
                                >
                                    <option value="">Select {brandPromotion[4].label}</option>
                                    {brandPromotion[4].data.map((option) => (
                                        <option key={option.value} value={option.value}>{option.value}</option>
                                    ))}
                                </select>
                            </div>
                            {errors[brandPromotion[4].name] && <p className="text-red text-sm">{errors[brandPromotion[4].name].message}</p>}
                        </div>
                        <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[6].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    {...register(brandPromotion[6].name)}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[6].name] ? "border-red" : ""}`}
                                >
                                    <option value="">Select {brandPromotion[6].label}</option>
                                    {brandPromotion[6].data.map((option) => (
                                        <option key={option.value} value={option.value}>{option.value}</option>
                                    ))}
                                </select>
                            </div>
                            {errors[brandPromotion[6].name] && <p className="text-red text-sm">{errors[brandPromotion[6].name].message}</p>}
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="flex flex-col flex-1 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[5].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <textarea
                                    placeholder={brandPromotion[5].placeholder}
                                    {...register(brandPromotion[5].name)}
                                    className={`flex-1 shrink self-stretch min-h-[100px] my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[5].name] ? "border-red" : ""}`}
                                />
                            </div>
                            {errors[brandPromotion[5].name] && <p className="text-red text-sm">{errors[brandPromotion[5].name].message}</p>}
                        </div>
                        <div className="flex flex-col flex-1 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {brandPromotion[7].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <textarea
                                    placeholder={brandPromotion[7].placeholder}
                                    {...register(brandPromotion[7].name)}
                                    className={`flex-1 shrink self-stretch min-h-[100px] my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[brandPromotion[7].name] ? "border-red" : ""}`}
                                />
                            </div>
                            {errors[brandPromotion[7].name] && <p className="text-red text-sm">{errors[brandPromotion[7].name].message}</p>}
                        </div>
                    </div>
                </FormSection>
            )}

            <FormSection title="Financial Details" defaultExpanded={false}>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {financialFields[0].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <input
                            type="text"
                            placeholder={financialFields[0].placeholder}
                            {...register(financialFields[0].name,)}
                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[financialFields[0].name] ? "border-red" : ""}`}
                        />
                    </div>
                    {errors[financialFields[0].name] && <p className="text-red text-sm">{errors[financialFields[0].name].message}</p>}
                </div>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {financialFields[1].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <input
                            type="text"
                            placeholder={financialFields[1].placeholder}
                            {...register(financialFields[1].name,)}
                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[financialFields[1].name] ? "border-red" : ""}`}
                        />
                    </div>
                    {errors[financialFields[1].name] && <p className="text-red text-sm">{errors[financialFields[1].name].message}</p>}
                </div>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {financialFields[2].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <input
                            type="text"
                            placeholder={financialFields[2].placeholder}
                            {...register(financialFields[2].name,)}
                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[financialFields[2].name] ? "border-red" : ""}`}
                        />
                    </div>
                    {errors[financialFields[2].name] && <p className="text-red text-sm">{errors[financialFields[2].name].message}</p>}
                </div>
            </FormSection>

            <FormSection title="Remarks" defaultExpanded={false}>
                <div className="flex flex-col gap-1">
                    <label className="text-[14px] font-[600] text-gray-900">
                        {impactFields[4].label}
                    </label>
                    <div className="w-full bg-white rounded-md">
                        <textarea
                            placeholder={impactFields[4].placeholder}
                            {...register(impactFields[4].name)}
                            className="w-full min-h-[180px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection title="Compliance & Agreements" defaultExpanded={false}>
                <div className="flex flex-col gap-6">
                    {/* Agreement Field */}
                    <div className="flex flex-col gap-2">
                        <label className="text-[14px] font-[600] text-gray-900">
                            Partnership Agreement Document
                        </label>
                        {/* <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder="Enter agreement document URL or upload file"
                                {...register('complianceAndAgreements.agreement')}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div> */}
                        {watch('complianceAndAgreements.agreements') && Array.isArray(watch('complianceAndAgreements.agreements')) && (
                            <div className="flex flex-col gap-2 mt-2">
                                {watch('complianceAndAgreements.agreements')
                                    .filter(url => url && url.trim() !== '') // Filter out empty strings
                                    .map((agreementUrl, index) => (
                                        <div key={index} className="flex items-center gap-2">
                                            <button
                                                type="button"
                                                onClick={() => window.open(agreementUrl, '_blank', 'noopener,noreferrer')}
                                                className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors text-sm font-medium"
                                            >
                                                View Agreement Document {index + 1}
                                            </button>
                                            <span className="text-xs text-gray-500 truncate max-w-xs">
                                                {agreementUrl}
                                            </span>
                                        </div>
                                    ))
                                }
                            </div>
                        )}
                    </div>

                    {/* Data Privacy Compliance Acknowledgement */}
                    <div className="flex flex-col gap-2">
                        <label className="text-[14px] font-[600] text-gray-900">
                            Data Privacy Compliance Acknowledgement
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <textarea
                                placeholder="Enter data privacy compliance acknowledgement details"
                                {...register('complianceAndAgreements.dataPrivacyComplianceAcknowledgement')}
                                className="w-full min-h-[100px] outline-primary px-4 py-2.5 rounded-md text-base border-none resize-none"
                            />
                        </div>
                    </div>

                    {/* File Upload Section for New Documents */}
                    <div className="border-t pt-4">
                        <FileHandler
                            label="Upload New Compliance Documents"
                            name="newComplianceDocuments"
                            value={watch('newComplianceDocuments') || []}
                            onChange={(files) => {
                                setValue('newComplianceDocuments', files);
                                // Optionally auto-populate the agreement URL if a file is uploaded
                                if (files.length > 0 && files[0].base64) {
                                    // You could process the file upload here and get a URL
                                    // For now, we'll just show the file is uploaded
                                }
                            }}
                            accept=".pdf,.doc,.docx"
                            multiple={true}
                            maxFileSize={10 * 1024 * 1024} // 10MB
                            maxFiles={50}
                            required={false}
                            disabled={isSubmitting}
                            error={errors.newComplianceDocuments?.message}
                        />
                        <p className="text-sm text-gray-600 mt-2">
                            Upload new compliance documents, agreements, certifications, and other legal documents.
                            These will be processed and the URLs will be updated in the fields above.
                            Supported formats: PDF, DOC, DOCX. Maximum file size: 10MB per file.
                        </p>
                    </div>
                </div>
            </FormSection>

            {/* Impact & Reporting Section */}
            <FormSection title="Impact & Reporting" defaultExpanded={false}>
                <div className="flex flex-wrap gap-3 w-full">
                    {/* Metrics Multi-Select */}
                    <div className="flex flex-col w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[0].label}
                        </label>
                        <Select
                            isMulti
                            options={impactFields[0].data}
                            placeholder={impactFields[0].placeholder}
                            value={impactFields[0].data.filter(opt =>
                                (watch('metricsDataPoints') || []).includes(opt.value)
                            )}
                            onChange={(selected) => {
                                const values = selected ? selected.map(opt => opt.value) : [];
                                setValue('metricsDataPoints', values);
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    backgroundColor: 'transparent',
                                    border: '1px solid rgba(236, 236, 238, 1)',
                                    borderRadius: '0.375rem',
                                    boxShadow: 'none',
                                    padding: '0.2rem',
                                    ":hover": { borderColor: '#16ad3c' },
                                }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                option: (base, { isSelected }) => ({
                                    ...base,
                                    backgroundColor: isSelected ? '#16ad3c' : 'white',
                                    color: isSelected ? 'white' : 'black',
                                    ":hover": { backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)' },
                                }),
                            }}
                        />
                    </div>

                    {/* Reporting Frequency Select */}
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register(impactFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            >
                                <option value="">{impactFields[1].placeholder}</option>
                                {impactFields[1].data?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.placeholder}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* A Short Paragraph On The Sponsor Company - Textarea */}
                    <div className="flex flex-col w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[2].label}
                        </label>
                        <textarea
                            {...register(impactFields[2].name)}
                            placeholder={impactFields[2].placeholder}
                            className="flex-1 w-full outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn min-h-[100px]"
                        />
                    </div>

                    {/* Reporting Goals */}
                    <div className="flex flex-col w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[3].label}
                        </label>
                        <textarea
                            {...register(impactFields[3].name)}
                            placeholder={impactFields[3].placeholder}
                            className="flex-1 w-full outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn min-h-[100px]"
                        />
                    </div>

                    {/* Remarks/Notes */}
                    <div className="flex flex-col w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[4].label}
                        </label>
                        <textarea
                            {...register(impactFields[4].name)}
                            placeholder={impactFields[4].placeholder}
                            className="flex-1 w-full outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn min-h-[100px]"
                        />
                    </div>
                </div>
            </FormSection>

            <div className="flex mt-5 justify-between">
                <ActionButton
                    variant={'reset'}
                    text={'Reset Form'}
                    type="button"
                    onClick={() => {
                        reset();
                        setImage(null);
                        // Reset any remaining useState fields if needed
                    }}
                />
                <div className="flex gap-5">
                    <ActionButton
                        variant={'cancel'}
                        text={'Cancel'}
                        type="button"
                        handleSubmit={() => {
                            navigate('/user/list/companies');
                        }}
                        onClick={() => {
                            navigate('/user/list/companies');
                        }}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Save'}
                        type="button"
                        disabled={isSubmitting}
                        onClick={handleSave}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Save and Register'}
                        type="button"
                        disabled={isSubmitting}
                        onClick={handleSaveAndRegister}
                    />
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={2000}
            />
        </form>
    );
};